import { API_URL, KEY, RESULTS_PER_PAGE } from "./config";
import { getJSON, sendJSON } from "./helpers";
import recipeView from "./views/recipeView";

//state gets modified by the code, then rendered in the DOM
export const state = {
  recipe: {},
  search: {
    query: "",
    results: [],
    page: 1,
    resultsPerPage: RESULTS_PER_PAGE,
  },
  bookmarks: [],
};

const createRecipeObject = function (data) {
  const { recipe } = data.data;
  return {
    id: recipe.id,
    title: recipe.title,
    publisher: recipe.publisher,
    sourceUrl: recipe.source_url,
    imageUrl: recipe.image_url,
    servings: recipe.servings,
    cookingTime: recipe.cooking_time,
    ingredients: recipe.ingredients,
    ...(recipe.key && { key: recipe.key }),
  };
};

export const loadRecipe = async function (id) {
  try {
    const data = await getJSON(`${API_URL}/${id}?key=${KEY}`);

    state.recipe = createRecipeObject(data);

    if (state.bookmarks.some((bookmark) => bookmark.id === id))
      // some() loops over an array and then return true if any of them have true for the specified condition
      state.recipe.bookmarked = true;
    else state.recipe.bookmarked = false;
  } catch (error) {
    recipeView.renderError(error.message);
    throw error;
  }
};

//loadSearchResult pushes all the search results into state.search.results
export const loadSearchResults = async function (query) {
  try {
    const data = await getJSON(`${API_URL}?search=${query}&key=${KEY}`);
    state.search.query = query;
    state.search.results = data.data.recipes.map((currentRecipe) => {
      return {
        id: currentRecipe.id,
        title: currentRecipe.title,
        publisher: currentRecipe.publisher,
        imageUrl: currentRecipe.image_url,
        ...(currentRecipe.key && { key: currentRecipe.key }),
      };
    });
  } catch (error) {
    throw error;
  }
};

// Pagination
export const getSearchResultsPage = function (page = 1) {
  state.search.page = page;
  const start = (page - 1) * state.search.resultsPerPage; // slice() is zero based
  const end = page * state.search.resultsPerPage;

  return state.search.results.slice(start, end);
};

export const updateServings = function (newServings) {
  state.recipe.ingredients.forEach((ingredient) => {
    ingredient.quantity =
      (ingredient.quantity * newServings) / state.recipe.servings;
  });

  state.recipe.servings = newServings;
};

export const addBookmark = function (state) {
  // add bookmark to state
  state.bookmarks.push(state.recipe);

  // Mark recipe as bookmarked
  state.recipe.bookmarked = true;

  // save bookmark to LocalStorage
  localStorage.setItem(state.recipe.id, JSON.stringify(state.recipe));
};

export const deleteBookmark = function (id) {
  // 1) removes bookmark from LocalStorage
  const bookmarkIdToDelete = state.bookmarks
    .filter((element) => element.id === id)
    .at(0).id;

  localStorage.removeItem(bookmarkIdToDelete);

  // 2) removes bookmark from state.bookmarks
  //find index of state.bookmarks[element.id, ...]
  const index = state.bookmarks.findIndex((element) => element.id === id);
  state.bookmarks.splice(index, 1);

  //  3) Mark current recipe as NOT bookmarked
  state.recipe.bookmarked = false;
};

export const getBookmarks = function () {
  // 1) Get all the bookmarks saved in localStorage
  const storageCopy = { ...localStorage };

  const bookmarksInLocalStorage = Object.values(storageCopy).map(
    (bookmarkString) => JSON.parse(bookmarkString)
  );

  // 2) restore localStorage bookmarks to state
  state.bookmarks = bookmarksInLocalStorage;

  // 3) return saved bookmarks to be handled in controller
  return bookmarksInLocalStorage;
};

//makes request to API

// export const uploadRecipe = async function (newRecipe) {
//   try {
//     //converting the data received from API
//     // console.log(Object.entries(newRecipe));

//     const ingredients = Object.entries(newRecipe)
//       .filter((entry) => entry[0].startsWith("ingredient") && entry[1] !== "")
//       .map((ingredient) => {
//         const ingredientsArray = ingredient[1].replaceAll(" ", "").split(",");
//makes request to API

// export const uploadRecipe = async function (newRecipe) {
//   try {
//     //converting the data received from API
//     // console.log(Object.entries(newRecipe));

//     const ingredients = Object.entries(newRecipe)
//       .filter((entry) => entry[0].startsWith("ingredient") && entry[1] !== "")
//       .map((ingredient) => {
//         const ingredientsArray = ingredient[1].replaceAll(" ", "").split(",");
//         const [quantity, unit, description] = ingredientsArray;

//         if (ingredientsArray.length !== 3)
//           throw new Error(
//             "Wrong ingredient format! Please use the correct format."
//           );

//         return { quantity: quantity ? +quantity : null, unit, description };
//       });
//     console.log(ingredients);

//     const recipe = {
//       // bookmarked:
//       cooking_time: +newRecipe.cookingTime,
//       // id:
//       imageUrl: newRecipe.image,
//       ingredients,
//       publisher: newRecipe.publisher,
//       servings: +newRecipe.servings,
//       sourceUrl: newRecipe.sourceUrl,
//       title: newRecipe.title,
//     };
//     const data = await sendJSON(`${API_URL}?key=${KEY}`, recipe);
//     console.log(data);
//   } catch (error) {
//     throw error;
//   }

//   // bookmarked:
//   // cookingTime:
//   // id:
//   // imageUrl:
//   // ingredients: [{qty, uniy}, {qty, uniy}]
//   // publisher:
//   // servings:
//   // sourceUrl:
//   // title:

//   // LEFT HERE, CONTINUE BUILDING THE NEW INGREDIENT (INGREDIENT FROM USER INPUT) TO MAKE IT EXACTLY LIKE THE RECIPE RECEIVED FROM THE API
// };

export const uploadRecipe = async function (newRecipe) {
  try {
    // {
    //   cookingTime: recipe.cooking_time,
    //   id: recipe.id,
    //   imageUrl: recipe.image_url,
    //   ingredients: recipe.ingredients,
    //   publisher: recipe.publisher,
    //   servings: recipe.servings,
    //   sourceUrl: recipe.source_url,
    //   title: recipe.title,
    // };

    const ingredients = Object.entries(newRecipe)
      .filter((entry) => entry[0].startsWith("ingredient") && entry[1] !== "")
      .map((ing) => {
        const ingArr = ing[1].split(",").map((el) => el.trim());

        if (ingArr.length !== 3) throw new Error("Wrong format");

        const [quantity, unit, description] = ingArr;
        return { quantity: quantity ? +quantity : null, unit, description };
      });

    const recipe = {
      cooking_time: +newRecipe.cookingTime,
      image_url: newRecipe.image,
      ingredients,
      publisher: newRecipe.publisher,
      servings: +newRecipe.servings,
      source_url: newRecipe.sourceUrl,
      title: newRecipe.title,
    };

    const data = await sendJSON(`${API_URL}?key=${KEY}`, recipe);

    //storing data returned from API (the data returned from the API is the data We send to the API)

    state.recipe = createRecipeObject(data);
    addBookmark(state);
  } catch (error) {
    throw error;
  }
};
